import { urlFullPath } from '@/helpers/urlHelpers'

export default {
  methods: {
    // Log the user in
    login() {
      this.$auth.loginWithRedirect()
    },
    // Log the user out
    logout() {
      this.$auth.logout({
        // returnTo: window.location.origin
        // returnTo: this.$router.resolve({ name: 'dashboard' }).route.fullPath
        returnTo: urlFullPath(this.$router.resolve({ name: 'dashboard' }).route.fullPath)
      })
    },
  },
}